import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  ConnectWithWix,
  IntegrationBenefits,
  Uninstall,
} from "./components";
import { SiWix } from "react-icons/si";
import {
  ClassNames,
  getCookie,
  // getDataFromDb,
  // updateDataInDb,
} from "../../../../helper";
import { FaAngleLeft } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { getDataFromMongoDb, updateDataInMongoDb } from "../../../../services/mongod.data";
const CF_Wix_API_URL =
  "https://us-central1-causalfunnel-21.cloudfunctions.net/CF_Wix_server";



const Wix = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [accessToken, setAccessToken] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const WixAuthCode = queryParams.get("code");
  const [install, setInstall] = useState(false);
  const [integration, setIntegration] = useState(false);
  const [integrationData, setIntegrationData] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const [code, setCode] = useState('');
  const [page, setPage] = useState(1);

  const installHandler = (state) => setInstall(state);
  

  useEffect(() => {
    // Function to parse the URL and extract the token parameter
    const parseUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenParam = urlParams.get('token');
      if (tokenParam) {
        setToken(tokenParam);
        window.location.href = `https://www.wix.com/installer/install?token=${tokenParam}&appId=c67b80de-41ef-4cf1-84c6-1c450cf24980&redirectUrl=https://dashboard.causalfunnels.com/integration/wix`;
        // window.location.href = `https://www.wix.com/installer/install?token=${tokenParam}&appId=c67b80de-41ef-4cf1-84c6-1c450cf24980&redirectUrl=http://localhost:3000/integration/wix`;
      }
    };

    // Call the function to parse the URL on component mount
    parseUrl();
  }, []);

  useEffect(() => {
    const parseRedirectedUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const codeParam = urlParams.get('code');
      if (codeParam) {
        setCode(codeParam);
      }
    };

    parseRedirectedUrl();
  }, []);

  // console.log(code)
  useEffect(() => {
    if (!integration) setIntegrationData({});
  }, [integration]);

  useEffect(() => {
    if (!WixAuthCode) return;
    setInstall(true);
    setLoading(true);

    const fetchData = async () => {
      try {
        const postData = {
          code: WixAuthCode,
        };
        const response = await axios.post(CF_Wix_API_URL, postData);
        
        const { accesss_token, refresh_token } = response.data;
        console.log("response", accesss_token)
        if (accesss_token) {
          setAccessToken(accesss_token);
          // let api_url = `${user}/graph-integration/wix`;
          // updateDataInDb(api_url, response.data);
          setIntegration(true);
          setInstall(true);
          setLoading(false);
          console.log("response.data", response.data, accesss_token, refresh_token);
          // database
          let api_url = `${user}/graph-integration/wix`;
          let result = await updateDataInMongoDb(user, "graph-integration", ["zoho"], { 'wix': response.data });
          console.log(api_url,result)
          setIntegration(true);
          navigate({ replace: true, search: "" });
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error.message);
      }
    };

    fetchData();
  }, [WixAuthCode]);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      try {
        let api_url = `${user}/graph-integration/wix`;
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let result = apiData.data.wix || apiData.data.data.wix;
        //
        // let result = await getDataFromDb(api_url);
        if (result) {
          setIntegration(true);
          setIntegrationData(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [user]);

  

  return (
    <div className="bg-gray-200 w-full p-3 relative">
      <NavLink
        to="/integration"
        className="text-indigo-600 text-lg text-semibold flex gap-1 items-center "
      >
        <FaAngleLeft className="text-sm" />
        Go back
      </NavLink>
      <div className="bg-white  p-4 rounded-md my-3">
        <header className="flex justify-between items-center border-bottom">
          <div className="my-3 flex items-center gap-3">
            <SiWix className="text-3xl text-gray-500" />
            <p className="text-lg font-semibold">Wix</p>
          </div>
          {integration && !install ? (
            <div className="space-x-2">
              <button
                className={ClassNames(
                  "text-gray-700 border p-1.5 rounded-md px-3.5 hover:cursor-pointer hover:bg-gray-100"
                )}
                onClick={() => setOpen(true)}
              >
                Uninstall
              </button>
              <button
                className={ClassNames(
                  "text-indigo-700 bg-indigo-200 p-1.5 rounded-md px-3.5 hover:bg-indigo-300 hover:cursor-pointer"
                )}
                onClick={() => {
                  
                  setInstall(true)
                }}
              >
                Configure
              </button>
            </div>
          ) : (
            <button
              className={ClassNames(
                "text-white bg-indigo-600 p-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer",
                install ? "hidden" : ""
              )}
              onClick={() => {
                setInstall(true); // Set install to true
              }}
              
            >
              Install Wix
            </button>
          )}
        </header>
        {install ? (
          <ConnectWithWix
            installHandler={installHandler}
            integrationData={integrationData}
            page={page}
            setPage={setPage}
            accessToken={accessToken}
          />
        ) : (
          <div className="relative">
            <Uninstall
              open={open}
              setOpen={setOpen}
              setIntegration={setIntegration}
            />
            <IntegrationBenefits />
          </div>
        )}
      </div>
    </div>
  );
};

export default Wix;
